import {
    addTrainingVideo
} from "./actions";
import { trainingVideoStoragePath } from "./trainingVideoPath.js";

export default {
    "label": "Training Videos",
    "key": "Training Videos",
    "location": "TrainingVideos",
    "headers": [{
        "headerName": "Name",
        "field": "Name",
        "flex": 1
    }],
    "actions": [{
        "label": "Add Training Video",
        "action": addTrainingVideo
    }],
    "rowActions": [{
        "label": "Watch",
        async action({ item, videoViewer, db, toast }) {
            const path = trainingVideoStoragePath(item);
            if (!path) {
                toast?.warning?.("This training video has no file.");
                return;
            }
            let url = await db.download(path);
            videoViewer.setSrc(url);
            videoViewer.setTitle(item.Name);
            videoViewer.toggle();
        }
    }]
}
